import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "flex flex-col lg:flex-row flex-wrap gap-2" };
const _hoisted_2 = {
    key: 0,
    class: "pt-4 text -mx-0.5"
};
const _hoisted_3 = { class: "key-label pb-1" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredFilters, ({ key, keyName, options, label, placeholder }) => {
            return (_openBlock(), _createElementBlock("div", null, [
                (key === 'x')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, "x"))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", _hoisted_3, _toDisplayString(label), 1 /* TEXT */),
                        _createVNode($setup["AjaxQueryWithSearchDropdown"], {
                            "filter-key": key,
                            "filter-key-name": keyName,
                            "filter-options": options,
                            by: "key",
                            placeholder: $setup.$t('Select'),
                            disabled: $setup.articlesStore.isLoadingStats,
                            pagination: true,
                            class: "min-w-[150px]"
                        }, null, 8 /* PROPS */, ["filter-key", "filter-key-name", "filter-options", "placeholder", "disabled"])
                    ], 64 /* STABLE_FRAGMENT */))
            ]));
        }), 256 /* UNKEYED_FRAGMENT */))
    ]));
}
